import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link as RouterLink } from "react-router-dom";
import { Container, Typography, Grid, Card, CardMedia, CardContent } from "@mui/material";
import { mediaThumb } from "../../services/media";

const API = "https://figazuresql.swancreate.com/api/crm";

export default function Gallery() {
  const [galleries, setGalleries] = useState([]);
  useEffect(() => {
    axios.get(`${API}/sk12_gallerymst?IsPublished=1`)
      .then((r) => setGalleries((r.data || []).filter((g) => g.IsPublished)));
  }, []);

  return (
    <Container sx={{ py: 6 }}>
      <Typography variant="h2" sx={{ mb: 4 }}>Gallery</Typography>
      {galleries.length === 0 && <Typography color="text.secondary">No galleries yet.</Typography>}
      <Grid container spacing={3}>
        {galleries.map((g) => (
          <Grid item xs={12} sm={6} md={4} key={g.apiid}>
            <Card component={RouterLink} to={`/gallery/${g.Slug}`} sx={{ textDecoration: "none", height: "100%" }}>
              {g.CoverImageUrl && <CardMedia component="img" height="200" image={mediaThumb(g.CoverImageUrl, 500)} alt={g.Title} />}
              <CardContent>
                <Typography variant="h6">{g.Title}</Typography>
                {g.Description && <Typography variant="body2" color="text.secondary" noWrap>{g.Description}</Typography>}
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}
